module.exports = __webpack_public_path__ + "static/sculpture-top-banner-3be3f028454657eacccbb73ce8767ed7.png";